/* Stealth Launch — Shopify section interactions.
   Self-initializing, scoped per [data-stealth] section, multi-instance safe. */
(function () {
  // ---- Guard against double-init (asset is referenced by every section) ----
  if (window.__stealthInit) return;
  window.__stealthInit = true;

  // ---- Enable reveal animations (content is visible by default in CSS) ----
  var inEditor = !!(window.Shopify && window.Shopify.designMode);
  document.documentElement.classList.add('stealth-anim');

  // ---- Sticky header (if a stealth header exists) ----
  var hdr = document.getElementById('lhdr');
  if (hdr) {
    var onScroll = function () { hdr.classList.toggle('solid', window.scrollY > 40); };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  // ---- Scroll reveal ----
  // In the theme editor (or when IntersectionObserver is unavailable) just reveal
  // everything immediately so merchants always see their content.
  function revealAll() {
    document.querySelectorAll('.reveal').forEach(function (el) { el.classList.add('in'); });
  }
  if (inEditor || !('IntersectionObserver' in window)) {
    revealAll();
  } else {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.14, rootMargin: '0px 0px -8% 0px' });
    document.querySelectorAll('.reveal').forEach(function (el, i) {
      el.style.transitionDelay = (Math.min(i % 4, 3) * 0.07) + 's';
      io.observe(el);
    });
    // Safety net: if anything hasn't revealed shortly after load, show it.
    window.addEventListener('load', function () {
      setTimeout(function () {
        document.querySelectorAll('.reveal:not(.in)').forEach(function (el) {
          var r = el.getBoundingClientRect();
          if (r.top < window.innerHeight) el.classList.add('in');
        });
      }, 600);
    });
  }

  // ---- Helpers ----
  function shade(hex, amt) {
    var c = hex.replace('#', '');
    if (c.length === 3) c = c.split('').map(function (x) { return x + x; }).join('');
    var n = parseInt(c, 16);
    var r = (n >> 16) + amt, g = ((n >> 8) & 255) + amt, b = (n & 255) + amt;
    r = Math.max(0, Math.min(255, r)); g = Math.max(0, Math.min(255, g)); b = Math.max(0, Math.min(255, b));
    return '#' + ((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1);
  }
  function setWeave(phone, hex) {
    var w = phone && phone.querySelector('.weave');
    if (!w) return;
    var lo = shade(hex, -10), hi = shade(hex, 18);
    w.style.background =
      'repeating-linear-gradient(45deg, ' + lo + ' 0 4px, ' + hi + ' 4px 8px),' +
      'repeating-linear-gradient(-45deg, rgba(255,255,255,.05) 0 4px, rgba(0,0,0,.22) 4px 8px)';
    w.style.backgroundBlendMode = 'overlay';
  }

  // ---- Colorways (per .ways section) ----
  document.querySelectorAll('.ways').forEach(function (sec) {
    var phone = sec.querySelector('#waysPhone, .ways-stage .phone-float');
    var ways = sec.querySelectorAll('.way');
    ways.forEach(function (btn) {
      btn.addEventListener('click', function () {
        ways.forEach(function (b) { b.classList.remove('active'); });
        btn.classList.add('active');
        setWeave(phone, btn.getAttribute('data-c'));
      });
    });
    // init with first active swatch color
    var active = sec.querySelector('.way.active') || ways[0];
    if (active) setWeave(phone, active.getAttribute('data-c'));
  });

  // ---- Stat counters ----
  var sio = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      var el = e.target, target = +el.getAttribute('data-target'), suffix = el.getAttribute('data-suffix') || '';
      var cur = 0, step = Math.max(1, Math.round(target / 24));
      (function tick() {
        cur = Math.min(target, cur + step);
        el.textContent = cur + suffix;
        if (cur < target) requestAnimationFrame(tick);
      })();
      sio.unobserve(el);
    });
  }, { threshold: 0.5 });
  document.querySelectorAll('.stat-n[data-target]').forEach(function (s) { sio.observe(s); });

  // ---- Countdown (per .countdown[data-launch]) ----
  function pad(n) { return String(n).padStart(2, '0'); }
  document.querySelectorAll('.countdown[data-launch]').forEach(function (cd) {
    var launch = new Date(cd.getAttribute('data-launch')).getTime();
    var d = cd.querySelector('[data-cd="d"]'), h = cd.querySelector('[data-cd="h"]'),
        m = cd.querySelector('[data-cd="m"]'), s = cd.querySelector('[data-cd="s"]');
    function tick() {
      var diff = launch - Date.now();
      if (isNaN(launch)) return;
      if (diff <= 0) { [d, h, m, s].forEach(function (x) { if (x) x.textContent = '00'; }); return; }
      if (d) d.textContent = pad(Math.floor(diff / 86400000));
      if (h) h.textContent = pad(Math.floor((diff % 86400000) / 3600000));
      if (m) m.textContent = pad(Math.floor((diff % 3600000) / 60000));
      if (s) s.textContent = pad(Math.floor((diff % 60000) / 1000));
    }
    tick();
    setInterval(tick, 1000);
  });

  // ---- Front-end demo signup (only when no Klaviyo action) ----
  document.querySelectorAll('form.js-signup').forEach(function (form) {
    var note = form.parentElement.querySelector('.js-signup-note');
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var input = form.querySelector('input');
      if (!input.value) return;
      if (note) { note.textContent = "You're on the list. We'll ping you when Stealth drops."; note.classList.add('done'); }
      input.value = ''; input.blur();
    });
  });
})();
